import React from 'react'
import * as S from './style'
import { node, func, bool, string } from 'prop-types'

const Button = ( { onClick, disabled, color, border, children } ) => {
  return (
    <S.Button
      border={ border }
      color={ color }
      disabled={ disabled }
      onClick={ onClick }
    >
      { children }
    </S.Button>
  )
}

Button.propTypes = {
  'border': string,
  'children': node.isRequired,
  'color': string.isRequired,
  'disabled': bool.isRequired,
  'onClick': func.isRequired,
}

Button.defaultProps = {
  'border': null,
}

export default Button
